import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { CurrentLocationEffects } from './current-location.effects';
import { currentLocationReducer } from './current-location.reducer';

@NgModule({
    declarations: [],
    imports: [CommonModule, StoreModule.forFeature('currentLocation', currentLocationReducer), EffectsModule.forFeature([CurrentLocationEffects])],
    exports: [],
    providers: [],
})
export class CurrentLocationStateModule {}
